if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.autoplayFirstMedia = this.dataset.autoplayFirstMedia === 'true';
      this.autoplayMedia = this.dataset.autoplayMedia === 'true';
      this.preloadVideoMedia = this.dataset.preloadVideoMedia === 'true';
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      if (this.autoplayFirstMedia) {
        this.playFirstMediaIfVideo();
      }
    }

    playFirstMediaIfVideo() {
      const firstMedia = this.elements.viewer.querySelector('ul li:first-child[data-media-id]');
      if (firstMedia) {
        if (firstMedia.querySelector('video-loader') || firstMedia.querySelector('externalvideo-player')) {
          setTimeout(() => {
          this.playActiveMedia(firstMedia);
          }, 1000);
        }
      }
    }

    onSlideChanged(event) {
       if (this.autoplayMedia) {
        this.playActiveMedia(event.detail?.currentElement);
      }
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail?.currentElement?.dataset?.mediaId }"]`);
      if (!thumbnail) return;
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        // if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
        //   activeMedia.scrollIntoView({behavior: 'smooth'});
        // }
      });

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      const internalMedia = activeItem.querySelector('video-loader');
      const externalMedia = activeItem.querySelector('externalvideo-player');

      //pause all external media
      const externalMedias = this.elements.viewer.querySelectorAll('externalvideo-player');
      externalMedias.forEach((media) => {
        if (media !== externalMedia) {
          if(media.hasAttribute('data-playing')) {
            media.pause();
          }
        }
      });
      //pause all internal media
      const internalMedias = this.elements.viewer.querySelectorAll('video-loader');
      internalMedias.forEach((media) => {
        const video = media.querySelector('video');
        if (media !== internalMedia) {
          if(video.paused === false) {
            console.log('Pausing internal media');
            video.pause();
            media.querySelector('play-trigger')?.setAttribute('aria-label', 'Paused');
          }
        }
      });

      if (internalMedia) {
        if(this.preloadVideoMedia) {
          internalMedia.querySelector('play-trigger')?.click();
        } else {
          setTimeout(() => {
            internalMedia.querySelector('play-trigger')?.click();
          }, 500);
        }
        this.elements.viewer.slider.scrollTo({ left: activeItem.offsetLeft });
        console.log('Playing internal media');
      } else if (externalMedia) {
        externalMedia.play();
        console.log('Playing external media');
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}